import { Component } from "@angular/core";
import { environment } from "src/environments/environment";

@Component({
    selector   : "footer",
    templateUrl: "./footer.component.html",
    styleUrls  : ["./footer.component.scss"]
})
export class FooterComponent
{
    public version: string = environment.version;

    /**
     * Constructor
     */
    constructor()
    {
    }
}
